import { render, staticRenderFns } from "./editProfile.vue?vue&type=template&id=df124e84&"
import script from "./editProfile.vue?vue&type=script&lang=js&"
export * from "./editProfile.vue?vue&type=script&lang=js&"
import style0 from "./editProfile.vue?vue&type=style&index=0&id=df124e84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports